// Filter der Seite Zahlungen (Kundenwunsch 13.10.2026: „filter bitte wie bei verkaufe extra button mit optionen
// einrichten“ statt der alten Filterzeile unter dem Tabellenkopf). Dieselben Funktionen und dasselbe Panel wie bei den
// Verkäufen (src/components/sales/saleFilters.js, SaleFilterMenu.vue) mit eigenen Listen und dem Betrag. Alles läuft im
// Browser über die geladenen Zahlungen des Monats; nichts wird gespeichert.
function billingMonth(row) {
  const month = Number(row.billing_month);
  const year = Number(row.billing_year);
  return month && year ? (month < 10 ? '0' : '') + month + '/' + year : null;
}

// Listen mit höchstens einem Wert blendet das Panel aus (z. B. Abrechnungsmonat bei Kunden ohne diese Angabe)
export const PAYMENT_FILTER_CONFIG = {
  lists: [
    { key: 'users', field: 'user_id', label: 'Benutzer' },
    { key: 'places', field: 'pay_place', label: 'Bezahlt wo' },
    { key: 'billing', field: 'billing_month', label: 'Abrechnungsmonat', value: billingMonth }
  ],
  amountField: 'amount',
  amountLabel: 'Betrag'
};

// Saldo (Kundenwunsch 13.10.2026: „saldo und fahrerabrechnung bitte ebenfalls nach diesem prinzip der anderen seiten
// anpassen“): Zeilen je Fahrer und Tag, gefiltert nach Fahrer, Zahlungsort und Abrechnungsmonat sowie dem Saldo
export const SALDO_FILTER_CONFIG = {
  lists: [
    { key: 'drivers', field: 'user_id', label: 'Fahrer' },
    { key: 'places', field: 'pay_place', label: 'Bezahlt wo' },
    { key: 'billing', field: 'billing_month', label: 'Abrechnungsmonat', value: billingMonth }
  ],
  amountField: 'diff_amount',
  amountLabel: 'Saldo'
};
